import React, { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { StockMenu } from "@/components/WatchAdd";

const TABS = [
  ["Long build-up", "text-emerald-600", "price ▲ OI ▲"],
  ["Short build-up", "text-rose-600", "price ▼ OI ▲"],
  ["Short covering", "text-sky-600", "price ▲ OI ▼"],
  ["Long unwinding", "text-amber-600", "price ▼ OI ▼"],
];
const sign = (v) => `${v > 0 ? "+" : ""}${v}%`;

export const OIPanel = () => {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState(TABS[0][0]);
  useEffect(() => {
    const load = () => api.get("/today/oi").then((r) => setD(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (!d) return <p className="text-xs font-mono text-slate-500">Loading…</p>;
  const rows = d.groups?.[tab] || [];
  return (
    <div data-testid="oi-panel">
      {d.indices?.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2" data-testid="oi-indices">
          {d.indices.filter((r) => ["NIFTY", "BANKNIFTY", "FINNIFTY", "MIDCPNIFTY"].includes(r.symbol)).map((r) => (
            <span key={r.symbol} className="text-[10px] font-mono border border-slate-200 px-1.5 py-0.5">
              <span className="text-slate-900 font-bold">{r.symbol}</span> OI <span className={r.oi_chg >= 0 ? "text-emerald-600" : "text-rose-600"}>{sign(r.oi_chg)}</span>
              <span className="text-slate-500"> · {r.buildup}</span>
            </span>
          ))}
        </div>
      )}
      <div className="grid grid-cols-4 gap-1 mb-2">
        {TABS.map(([t, c, h]) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`oi-tab-${t.split(" ")[0].toLowerCase()}-${t.split(" ")[1]}`}
            className={`text-[10px] font-mono font-bold px-1 py-1 border ${tab === t ? `border-blue-500 ${c} bg-blue-100/40` : "border-slate-200 text-slate-500 hover:text-slate-800"}`} title={h}>
            {t}<span className="block font-normal text-slate-500">{h}</span>
          </button>
        ))}
      </div>
      {!rows.length && <p className="text-xs font-mono text-slate-500 py-3" data-testid="oi-empty">{d.at ? "No stocks in this group" : "OI fills in once the live session starts"}</p>}
      <div className="space-y-px">
        {rows.map((r) => (
          <StockMenu key={r.symbol} instrumentId={r.instrument_id} symbol={r.symbol}>
          <div className="flex items-center justify-between text-xs font-mono px-1.5 py-1 hover:bg-slate-100 cursor-pointer"
            data-testid={`oi-row-${r.symbol}`}>
            <span className="text-slate-900 font-semibold w-28 truncate">{r.symbol}<span className="block text-[9px] text-slate-500 font-normal">{r.sector}</span></span>
            <span className="text-slate-600">{inr(r.fut_price)}</span>
            <span className={r.price_chg >= 0 ? "text-emerald-600" : "text-rose-600"}>{sign(r.price_chg)}</span>
            <span className={`font-bold ${r.oi_chg >= 0 ? "text-blue-600" : "text-amber-600"}`}>OI {sign(r.oi_chg)}</span>
          </div>
          </StockMenu>
        ))}
      </div>
      {d.at && <p className="text-[9px] font-mono text-slate-500 mt-1.5">near-month futures · updated {new Date(d.at).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata" })} IST</p>}
    </div>
  );
};
